import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "@project/lib/locales/en";
import { gu } from "@project/lib/locales/gu";

export type Lang = "en" | "gu";

export const SUPPORTED_LANGS: Lang[] = ["en", "gu"];
export const DEFAULT_LANG: Lang = "en";
const LANG_STORAGE_KEY = "lang";

export function getStoredLang(): Lang {
  if (typeof window === "undefined") {
    return DEFAULT_LANG;
  }
  try {
    return localStorage.getItem(LANG_STORAGE_KEY) === "gu" ? "gu" : "en";
  } catch {
    return DEFAULT_LANG;
  }
}

// A dedicated instance for the public/user site so it never clashes with the
// API-backed admin i18n singleton living in `src/i18n`.
const i18n = i18next.createInstance();

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    gu: { translation: gu },
  },
  lng: getStoredLang(),
  fallbackLng: DEFAULT_LANG,
  supportedLngs: SUPPORTED_LANGS,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language;
}

export function setLanguage(lang: Lang) {
  if (typeof window !== "undefined") {
    try {
      localStorage.setItem(LANG_STORAGE_KEY, lang);
    } catch {
      // ignore storage errors (e.g. private mode)
    }
  }
  void i18n.changeLanguage(lang);
  if (typeof document !== "undefined") {
    document.documentElement.lang = lang;
  }
}

export default i18n;
